import { urlBuilder } from '@/shared/utils';

import {
	PROMO_BAR_END_DATE,
	PROMO_BAR_HIDE_DURATION,
	PROMO_BAR_STORAGE_KEY,
} from '../constants';

export const isPromoBarExpired = (): boolean => {
	if (typeof window === 'undefined') return true;

	// Проверяем дату окончания промобара
	const now = Date.now();
	if (now > PROMO_BAR_END_DATE) {
		return true;
	}

	// Проверяем, был ли промобар закрыт пользователем
	const closedTimestamp = localStorage.getItem(PROMO_BAR_STORAGE_KEY);
	if (!closedTimestamp) return false;

	const closedTime = parseInt(closedTimestamp, 10);
	const timeSinceClosed = now - closedTime;

	// Если прошла неделя, считаем что промобар можно показать снова
	return timeSinceClosed < PROMO_BAR_HIDE_DURATION;
};

export const shouldShowPromoBarOnPage = (pathname: string): boolean => {
	// Главная страница с задачами
	if (pathname === urlBuilder.problems()) return true;

	// Страница курса (ровно /courses/[courseId], без вложенных роутов)
	if (pathname.startsWith('/courses/')) {
		const segments = pathname.split('/').filter(Boolean);
		// ['courses', '<id>']
		if (segments.length === 2) {
			return true;
		}
	}

	// Страница чатов
	if (pathname === '/community-hub') return true;

	// Лендинги
	if (
		pathname === '/algorithms' ||
		pathname === '/community' ||
		pathname === '/system-design' ||
		pathname === '/system-design-trial'
	) {
		return true;
	}

	return false;
};
